import React from 'react';
import errorImage from './../../src/images/img-error@2x.png';

export const Maintenance = () => {
  return (
    <article className='error'>
      <div className='error__body'>
        <div className='error__title'>ただいまメンテナンス中です。</div>
        <div className='error__image'>
          <img src={errorImage} alt='' />
        </div>
        <p className='error__message'>
          大変申し訳ございません。現在システムメンテナンスを行なっているため
          <br />
          Buildeeをご利用いただくことができません。
        </p>
        <p className='error__message'>
          【メンテナンス終了予定時刻】
          <br />
          ~2018年10月26日 21:00
        </p>
        <p className='error__message'>
          メンテナンス終了まで、今しばらくお待ちください。
        </p>
      </div>
    </article>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Maintenance.jsx